import { addLabelText, removeSpritesInObject } from "../../../../helpers/createTextSprite";
import { resetAndDispatchParams } from "../../../../helpers/resetAndDispatchParams";
import { handleLoadedObject } from "../../../addObjectToScene";
import { setActiveCalcValue } from "../../../calculator";
import { changeTableColor } from "../tables/down/down";

// ----- CONSTANTS -----
const SELECTORS = {
    title: ".menu_title",
};

const TITLE_CONFIG = {
    base: "Шкаф инструментальный",
    suffixes: {
        shi: "ШИ",
        shir: "ШИР",
        shio: "ШИО",
        ship: "ШИП",
    },
};

const OBJECT_NAMES = {
    shi: "shkaf__shi__ship__2000x1020x620",
    ship: "shkaf__shi__ship__2000x1020x620",
    shir: "shkaf__shir__shio__2000x1020x620",
    shio: "shkaf__shir__shio__2000x1020x620",
};

const DEFAULT_COLOR = "#cbd0cc";

export const LOAD_DATA = {
    shi: {
        actual: true,
        name: "shkaf__shi__ship__2000x1020x620",
        pageName: "instrumentalniy",
        tempName: "instrumentalniy",
        glbPath: "wardrobes/",
        glbName: "shkafy_shi.glb",
        nextMenu: "instrumentalniy",
        menuTitle: "Шкаф инструментальный (ШИ)",
        title: "Шкаф инструментальный",
        imgName: "wardrobe_instrumentalniy.webp",
        allArrTable: "allWardrobes",
        defaultHeight: 2000,
        defaultWidth: 1020,
        defaultDepth: 620,
        folderName: "wardrobes",
        wardrobeType: "shi",
        typeName: "metall_type",
    },
    ship: {
        actual: true,
        name: "shkaf__shi__ship__2000x1020x620",
        pageName: "instrumentalniy",
        tempName: "instrumentalniy",
        glbPath: "wardrobes/",
        glbName: "shkafy_shi.glb",
        nextMenu: "instrumentalniy",
        menuTitle: "Шкаф инструментальный (ШИП)",
        title: "Шкаф инструментальный",
        imgName: "wardrobe_instrumentalniy.webp",
        allArrTable: "allWardrobes",
        defaultHeight: 2000,
        defaultWidth: 1020,
        defaultDepth: 620,
        folderName: "wardrobes",
        wardrobeType: "ship",
        typeName: "metall_type",
    },
    shir: {
        actual: true,
        name: "shkaf__shir__shio__2000x1020x620",
        pageName: "instrumentalniy",
        tempName: "instrumentalniy",
        glbPath: "wardrobes/",
        glbName: "shkafy_shi.glb",
        nextMenu: "instrumentalniy",
        menuTitle: "Шкаф инструментальный (ШИР)",
        title: "Шкаф инструментальный",
        imgName: "wardrobe_instrumentalniy.webp",
        allArrTable: "allWardrobes",
        defaultHeight: 2000,
        defaultWidth: 1020,
        defaultDepth: 620,
        folderName: "wardrobes",
        wardrobeType: "shir",
        typeName: "metall_type",
    },
    shio: {
        actual: true,
        name: "shkaf__shir__shio__2000x1020x620",
        pageName: "instrumentalniy",
        tempName: "instrumentalniy",
        glbPath: "wardrobes/",
        glbName: "shkafy_shi.glb",
        nextMenu: "instrumentalniy",
        menuTitle: "Шкаф инструментальный (ШИО)",
        title: "Шкаф инструментальный",
        imgName: "wardrobe_instrumentalniy.webp",
        allArrTable: "allWardrobes",
        defaultHeight: 2000,
        defaultWidth: 1020,
        defaultDepth: 620,
        folderName: "wardrobes",
        wardrobeType: "shio",
        typeName: "metall_type",
    },
};

// ----- DOM CACHE -----
let titleNode = null;

const getTitleNode = () => {
    if (!titleNode || !titleNode.isConnected) {
        titleNode = document.querySelector(SELECTORS.title);
    }
    return titleNode;
};

// ----- PURE -----
const formatTitleText = (key) => {
    const suffix = TITLE_CONFIG.suffixes[key];
    if (!suffix) {
        throw new Error(`Invalid key: "${key}"`);
    }
    return `${TITLE_CONFIG.base} (${suffix})`;
};

const updateUI = (value) => {
    updateTitle(value);
    resetAndDispatchParams({ exceptName: "komplektatsia" });
};

const updateTitle = (value) => {
    const node = getTitleNode();

    if (!node) {
        console.warn("Title node not found");
        return;
    }

    const text = formatTitleText(value);

    if (node.textContent !== text) {
        node.textContent = text;
    }
};

const getLoadData = (wardrobeType) => {
    return LOAD_DATA[wardrobeType];
};

// ----- PUBLIC API -----
export const changeKomplektatsia = async ({ value }) => {
    updateUI(value);

    const objectName = OBJECT_NAMES[value];
    const prevKomplekt = servObj.redactorModeObject.userData.loadData.wardrobeType;
    const prev_calc_table_name = `shkaf__${prevKomplekt}__2000`;
    const calc_table_name = `shkaf__${value}__2000`;
    const loadData = getLoadData(value);

    setActiveCalcValue(prev_calc_table_name, false);

    if (typeof objectName !== "string") {
        console.warn(`[changeKomplektatsia]: название объекта не было найдено. value: ${value}`);
        return;
    }

    if (servObj.redactorModeObject) {
        servObj.redactorModeObject.traverse((c) => {
            if (c.geometry) c.geometry.dispose?.();
            if (c.material) {
                const mats = Array.isArray(c.material) ? c.material : [c.material];
                mats.forEach((m) => m.dispose?.());
            }
        });

        servObj.building.removeObject(servObj.redactorModeObject);
        servObj.redactorModeObject = null;
    }

    const target = handleLoadedObject({
        objectName,
        calc_table_name,
        isLoadFromJSON: false,
        loadData,
    });
    changeTableColor("changeable_painted_metal_material", DEFAULT_COLOR);

    if (!target) {
        console.error("Failed to create object");
        return;
    }

    removeSpritesInObject(target);
    addLabelText(target, value);
};
